var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 55,
    viewBox: "0 0 57 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52538 29.5597C3.75672 30.0215 3.12035 30.674 2.67791 31.454C2.23548 32.2339 2.00197 33.115 2 34.0117V42.447C2.00197 43.3437 2.23548 44.2247 2.67791 45.0047C3.12035 45.7846 3.75672 46.4371 4.52538 46.8989L12.3358 51.5852C13.1457 52.0717 14.0727 52.3288 15.0174 52.3288C15.9622 52.3288 16.8892 52.0717 17.699 51.5852L28.0349 45.3889V31.0697L15.0174 23.2593L4.52538 29.5597V29.5597Z",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0183 38.8799L2.67773 31.46",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0176 38.88L28.035 31.0696",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0176 38.88V52.34",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0352 31.0697V45.3889L38.371 51.5852C39.1808 52.0717 40.1078 52.3288 41.0526 52.3288C41.9974 52.3288 42.9243 52.0717 43.7342 51.5852L51.5446 46.8989C52.3133 46.4371 52.9497 45.7846 53.3921 45.0047C53.8345 44.2247 54.068 43.3437 54.07 42.447V34.0117C54.068 33.115 53.8345 32.2339 53.3921 31.454C52.9497 30.674 52.3133 30.0215 51.5446 29.5597L41.0526 23.2593L28.0352 31.0697Z",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0526 38.88L28.0352 31.0696",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0518 38.8799L53.3923 31.46",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0518 38.88V52.34",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.543 7.42988C16.7743 7.89169 16.1379 8.54418 15.6955 9.32414C15.2531 10.1041 15.0195 10.9851 15.0176 11.8818V23.2591L28.035 31.0695L41.0524 23.2591V11.8818C41.0505 10.9851 40.817 10.1041 40.3745 9.32414C39.9321 8.54418 39.2957 7.89169 38.5271 7.42988L30.7166 2.74361C29.9067 2.25705 28.9798 2 28.035 2C27.0902 2 26.1633 2.25705 25.3534 2.74361L17.543 7.42988V7.42988Z",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0358 16.7504L15.6953 9.33044",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0352 16.7504L40.3757 9.33044",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0352 31.0695V16.7504",
    stroke: "#204269",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.7d0b1a6732ef57d42b6e44a7efdef17f.svg";
export { ForwardRef as ReactComponent };